import moment from "moment";

const isLikelyBase64 = (value) => {
  if (typeof value !== "string" || value.length === 0 || value.length % 4 === 1) {
    return false;
  }

  return /^[A-Za-z0-9+/=_-]+$/.test(value);
};

function useAuthorization() {
  const decodeToken = (token) => {
    const payloadSegment = token?.split(".")?.[1];
    if (!isLikelyBase64(payloadSegment)) {
      return null;
    }

    const normalizedPayload = payloadSegment.replaceAll("-", "+").replaceAll("_", "/");
    return JSON.parse(atob(normalizedPayload));
  };

  const validateToken = (token) => {
    if (!token) return false;
    const decodedToken = decodeToken(token);
    if (decodedToken?._id) return true;
    if (decodedToken?.exp) {
      const expirationTime = moment.unix(decodedToken.exp);
      const currentTime = moment().unix();
      if (expirationTime.isAfter(currentTime)) return true;
    }
    return false;
  };
  return { decodeToken, validateToken };
}

export default useAuthorization;
